import { HistoryTotalStatus } from '../types/history'

type Translate = (key: string, options?: Record<string, unknown>) => string

export interface HistoryPaginationMeta {
    total_pages?: number
    page_depth_limit?: number
    max_accessible_page?: number
    pagination_limited?: boolean
}

export const getHistoryPaginationTotal = (
    _meta: HistoryPaginationMeta,
    _pageSize: number,
    total: number
): number => {
    return total
}

export const renderHistoryPaginationTotal = (
    t: Translate,
    options: {
        total: number
        totalStatus: HistoryTotalStatus
        pageSize: number
        meta?: HistoryPaginationMeta
    }
): string => {
    const { total } = options
    return t('table.total', { total })
}
